'use client';

import { Button } from '@spikemark/ui/components/ui/button';
import { FC } from 'react';
import { useIntercom } from 'react-use-intercom';
/* @TODO SCO-280: This can be deleted once coach portal changes go live,
 ** update `apps/web/components/app-header.tsx` to include the original coach portal button
 */
export const IntercomCoachPortalButton: FC = () => {
  const {
    trackEvent
  } = useIntercom();
  const handleClick = () => {
    trackEvent('prelaunch_splash_clicked');
  };
  return <div className="block grid place-items-center p-2 lg:px-3 xl:px-4 h-full hover:bg-white/10" data-sentry-component="IntercomCoachPortalButton" data-sentry-source-file="intercom-coach-portal-button.tsx">
      <Button variant="primary" id="prelaunch_splash_clicked" onClick={handleClick} className="my-0.5 whitespace-nowrap text-base bg-accent hover:bg-accent/80" size="lg" data-sentry-element="Button" data-sentry-source-file="intercom-coach-portal-button.tsx">
        Coach Portal
      </Button>
    </div>;
};